export const START_INDEX = 10000;
const messageExists = (messages, message) => messages.findIndex((m) => m.clientId === message.clientId) !== -1;
const updateMessageWithStatus = (messages, message, status) => {
    const replyMessage = messages.find((m) => m.serverId === message.replyId && message.replyId.length !== 0);
    const updated = Object.assign(Object.assign({}, message), { status, reply: replyMessage });
    return messages.map((m) => (m.clientId === updated.clientId ? updated : m));
};
const updateMessageWithReply = (messages, message) => {
    const replyMessage = messages.find((m) => m.serverId === message.replyId && message.replyId.length !== 0);
    return Object.assign(Object.assign({}, message), { reply: replyMessage });
};
const updateMessagesWithReply = (messages) => {
    return messages.map((message) => {
        var _a;
        if (((_a = message.replyId) === null || _a === void 0 ? void 0 : _a.length) !== 0) {
            const replyMessage = messages.find((m) => m.serverId === message.replyId && message.replyId.length !== 0);
            return Object.assign(Object.assign({}, message), { reply: replyMessage });
        }
        return message;
    });
};
export const messageListInitialState = {
    messages: [],
    newMessagesCount: 0,
    moreDataIsAvailable: true,
    firstItemIndex: START_INDEX,
    topMostIndex: 0,
    isLoading: false,
    catchupFromId: undefined,
    isChannelModerator: false,
};
export const messageListReducer = (state = messageListInitialState, action) => {
    switch (action.type) {
        case "initialize":
            return Object.assign(Object.assign({}, state), { firstItemIndex: START_INDEX - action.messages.length, messages: updateMessagesWithReply(action.messages), moreDataIsAvailable: action.moreDataIsAvailable, topMostIndex: START_INDEX - 1, isChannelModerator: false });
        case "currentUserIsModerator":
            return Object.assign(Object.assign({}, state), { isChannelModerator: true });
        case "loading":
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case "loaded": {
            const sortedMessages = action.messages.sort((a, b) => a.date.localeCompare(b.date));
            return Object.assign(Object.assign({}, state), { messages: sortedMessages.concat(state.messages), isLoading: false, firstItemIndex: state.firstItemIndex - action.messages.length, moreDataIsAvailable: action.moreDataIsAvailable });
        }
        case "loadingFailed":
            return Object.assign(Object.assign({}, state), { isLoading: false, moreDataIsAvailable: false });
        case "newMessage": {
            const messageWithReply = updateMessageWithReply(state.messages, action.message);
            if (messageExists(state.messages, action.message)) {
                return Object.assign(Object.assign({}, state), { messages: updateMessageWithStatus(state.messages, messageWithReply, undefined) });
            }
            return Object.assign(Object.assign({}, state), { messages: state.messages.concat(messageWithReply), newMessagesCount: state.newMessagesCount + 1 });
        }
        case "catchup": {
            if (state.catchupFromId) {
                return state;
            }
            if (action.fromId) {
                return Object.assign(Object.assign({}, state), { catchupFromId: action.fromId });
            }
            const lastMessage = state.messages
                .reverse()
                .find((m) => m.serverId.length > 0);
            if (lastMessage) {
                return Object.assign(Object.assign({}, state), { catchupFromId: lastMessage.serverId });
            }
            return state;
        }
        case "catchupComplete": {
            return Object.assign(Object.assign({}, state), { catchupFromId: undefined });
        }
        case "newMessages": {
            const existingMessages = state.messages.filter((existingMessage) => !action.messages.some((newMessage) => existingMessage.clientId === newMessage.clientId));
            const messages = existingMessages
                .concat(action.messages)
                .sort((a, b) => a.date.localeCompare(b.date));
            const updatedCount = state.messages.length - existingMessages.length;
            const newMessagesCount = state.newMessagesCount + (action.messages.length - updatedCount);
            return Object.assign(Object.assign({}, state), { messages,
                newMessagesCount });
        }
        case "sendingMessage": {
            return Object.assign(Object.assign({}, state), { messages: state.messages.concat(Object.assign(Object.assign({}, action.message), { status: "sending" })), newMessagesCount: state.newMessagesCount + 1, topMostIndex: START_INDEX + state.newMessagesCount + 1 });
        }
        case "messageFailed":
            return Object.assign(Object.assign({}, state), { messages: updateMessageWithStatus(state.messages, action.message, "failed") });
        case "messageRemoved":
            return Object.assign(Object.assign({}, state), { messages: state.messages.filter((message) => message.serverId !== action.serverId) });
        case "messageUpdated":
            return Object.assign(Object.assign({}, state), { messages: state.messages.map((message) => message.clientId === action.message.clientId
                    ? Object.assign(Object.assign({}, message), action.message) : message) });
        default:
            break;
    }
    return state;
};
//# sourceMappingURL=reducer.js.map